import {Injectable} from '@angular/core';
import Swal, {SweetAlertOptions, SweetAlertResult} from 'sweetalert2';

export const SwalDismissReason = Swal.DismissReason;

@Injectable()
export class SwalService {

  show(opts: SweetAlertOptions): Promise<SweetAlertResult> {
    return Swal.fire({
      ...opts,
      allowOutsideClick: false,
      // buttonsStyling: false,
      // customClass: {
      //   confirmButton: 'mat-raised-button mat-button-base mat-primary',
      //   cancelButton: 'mat-raised-button mat-button-base'
      // },
      /*cancelButtonClass: 'mat-raised-button mat-button-base',
      confirmButtonClass: 'mat-raised-button mat-button-base mat-primary',*/
      reverseButtons: true,
    });
  }

  /**
   * Show a swal of type "error"
   */
  showError(opts: SweetAlertOptions) {
    return this.show({...opts});
  }

  /**
   * Show a swal of type "error" in toast mode
   */
  showErrorToast(opts: SweetAlertOptions) {
    return this.show({
      position: 'top-end',
      showConfirmButton: false,
      timer: 3000,
      ...opts,
      toast: true
    });
  }

  /**
   * Show a swal of type "confirm"
   */
  showConfirm(opts: SweetAlertOptions) {
    return this.show({
      ...opts,
      cancelButtonText: 'No',
      confirmButtonText: 'Si',
      showCancelButton: true,
      showConfirmButton: true,
    }).then(({value}) => value);
  }

  /**
   * Show a swal of type "success"
   */
  showSuccess(opts: SweetAlertOptions) {
    return this.show({...opts});
  }

  /**
   * Show a swal of type "success" in toast mode
   */
  showSuccessToast(opts: SweetAlertOptions) {
    return this.show({
      position: 'top-end',
      showConfirmButton: false,
      timer: 3000,
      ...opts,
      customClass: { popup: 'toast-container' },
      width: '20rem'
    });
  }

  /**
   * Show a swal of type "input" and do nothing upon cancel
   */
  showInput(opts: SweetAlertOptions) {
    return this.show({
      input: 'text',
      showCancelButton: true,
      ...opts,
      showConfirmButton: true,
    });
  }

  /**
   * Show a swal of type "warning"
   */
  showWarning(opts: SweetAlertOptions) {
    return this.show({...opts});
  }
}
